const assignment = {
  assignment: "Aufgabe",
  create: "Neue Aufgabe erstellen",
  creation: "Aufgabe erstellen",
  update: "Aufgabe bearbeiten",
  view: "Aufgabenübersicht",
  creationInstruction: "Legen Sie die Einstellungen für Ihre Aufgabe fest.",
  number: "Nr.",
  name: "Name",
  lastEdited: "Zuletzt geändert",
  classes: "Klassen",
  follow: "Meine Aufgaben",
  followed: "Meine Aufgaben",
  finishDate: "Abgabedatum",
  mandatoryStartDate: "Startdatum ist erforderlich.",
  mandatoryFinishDate: "Abgabedatum ist erforderlich.",
  finishDateCondition:
    "Das Abgabedatum muss nach dem Startdatum und nach dem heutigen Datum liegen.",
  save: "Aufgabe speichern",
  saveAndPublish: "Speichern und veröffentlichen",
  selectExercisesInstruction:
    "Wählen Sie die Übungen aus, die Sie Ihrem Auftrag hinzufügen möchten, indem Sie auf die Symbole klicken.",
  visualizeHomeworkInstruction:
    "Sehen Sie sich Ihre Aufgabe vor dem Speichern in der Vorschau an.",
  teacherNoHomework: "Sie haben noch keine Aufgaben erstellt.",
  deleteHomeworkQuestion: "Diese Aufgabe löschen?",
  deleteHomeworkDescription:
    "Diese Aufgabe ist danach nicht mehr verfügbar. Alle zugehörigen Daten werden dauerhaft gelöscht.",
  notOpened: "Nicht begonnen",
  notCompleted: "Unvollständig",
  noGradeNotCompleted: "Unvollständig",
  homeworkNotOpened: "Aufgabe nicht begonnen",
  homeworkNotFinished: "Aufgabe unvollständig",
  all_levels: "Alle Niveaus",
  followMyHomeworks: "Meine Aufgaben",
  homework: "Aufgabe",
  mockTest: "Probetest",
  mockTestNumber: "Probetest Nr.",
  completeHomework: "Aufgabe bearbeiten",
  completeHomeworkAgain: "Aufgabe wiederholen",
  mockTestName: "Name des Probetests:",
  homeworkName: "Name der Aufgabe:",
  homeworkStartDate: "Startdatum",
  homeworkFinishDate: "Abgabedatum",
  homeworkStatus: "Status",
  homeworkStartDateWithColon: "Startdatum:",
  homeworkFinishDateWithColon: "Abgabedatum:",
  homeworkStatusWithColon: "Status",
  homeworkStatusComing: "Bevorstehend",
  homeworkStatusOngoing: "Offen",
  homeworkStatusExpired: "Geschlossen",
  homeworkNote: "Punktzahl:",
  exerciseList: "Übungsliste",
  emptyHomeworks: "Keine Aufgaben zugewiesen.",
  homeworkNumber: "Aufgabe Nr.",
  homeworkNumberColon: "Aufgabe Nr. {number}:",
  homeworkCompleted: "Aufgabe abgeschlossen!",
  mockTestCompleted: "Probetest abgeschlossen!",
  yourMark: "Ihre Punktzahl:",
  backToHomeworks: "Zurück zu meinen Aufgaben",
  homeworkAttempt: "Versuch",
  homeworkAttempts: "Versuche",
  gradeUnfinishedHomeworks: "Unvollständige Aufgaben bewerten",
  gradeUnfinishedHomeworksDetails:
    "Schülerinnen und Schüler dieser Klasse, die eine vergangene Aufgabe nicht abgeschlossen haben, werden auf Grundlage ihrer abgegebenen Antworten bewertet. Diese Aktion wird auf alle unvollständigen Aufgaben dieser Klasse angewendet. Diese Aktion kann nicht rückgängig gemacht werden.",
};

export default assignment;
